import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { AppUtils } from "@app/shared/util/app.utils";
import { PagedResponse } from "@app/shared/models/response.model";
import { InsertionCycle } from "@app/shared/models/insertion-cycle.model";
import { PartNumber } from "@app/shared/models/partNumber.model";
import { map } from "rxjs/operators";

@Injectable()
export class InsertionCyclesService {
    private readonly API_INSERTION_CYCLES_BASE_PATH = `${environment.baseURL}/api/insertionCycles`;

    constructor(private http: HttpClient) {

    }

    public getInsertionCycles(tableConfig: TableConfig = new TableConfig) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<InsertionCycle>>(`${this.API_INSERTION_CYCLES_BASE_PATH}`, {params: params});
    }

    public getInsertionCyclesByLineAndByPartNumbers(lineId: number, partNumbers: PartNumber[]) {
        let params = new HttpParams();
        if (lineId) {
            params = params.set('LineIds', lineId.toString());
        }

        partNumbers.forEach( item =>
            params = params.append('PartNumbersIds', item.id.toString())
        );

        return this.http.get<PagedResponse<InsertionCycle>>(this.API_INSERTION_CYCLES_BASE_PATH, {params: params})
                        .pipe(map(this.mapInsertionCycles));
    }

    mapInsertionCycles = res => {
        return {
            items: res.items.map(ic => new InsertionCycle(ic)),
            count: res.total
        };
    };

    public createInsertionCycle(insertionCycle: InsertionCycle) {
        const payload = {
            name: insertionCycle.name,
            lineIds: insertionCycle.assignedLines.map(x => x.id)
        };
        return this.http.post<InsertionCycle>(`${this.API_INSERTION_CYCLES_BASE_PATH}`, payload);
    }

    public updateInsertionCycle(insertionCycle: InsertionCycle) {
        const payload = {
            id: insertionCycle.id,
            name: insertionCycle.name,
            lineIds: insertionCycle.assignedLines.map(x => x.id)
        }
        return this.http.put<InsertionCycle>(`${this.API_INSERTION_CYCLES_BASE_PATH}`, payload);
    }

    public deleteInsertionCycle(insertionCycleId: number) {
        return this.http.delete(`${this.API_INSERTION_CYCLES_BASE_PATH}?id=${insertionCycleId}`)
    }

    public getInsertionCyclesByLinesIds(ids: number[]) {
        if (!ids) {
            return;
        }
        let params = new HttpParams();
        ids.forEach( id =>
            params = params.append('lineIds', id.toString())
        );
        return this.http.get(`${this.API_INSERTION_CYCLES_BASE_PATH}`, {params: params})
    }
}
